import React from 'react';
import { ModalBody, ModalButtons, ModalClose, ModalContent, ModalHeadline, ModalStyled } from './Modal.styles';
const Modal = ({ children, eventHandler = () => null, open, onClose, headline, buttons, justifyButtons, justifyHeadline, size, ...props }) => {
    return (React.createElement(ModalStyled, { open: open, onClose: onClose, size: size, ...props },
        React.createElement(ModalClose, { onClick: onClose }),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeadline, { align: justifyHeadline }, headline),
            React.createElement(ModalBody, null, children)),
        buttons &&
            React.createElement(ModalButtons, { justifyButtons: justifyButtons }, buttons.map((button, i) => {
                return React.cloneElement(button, { key: button.key || i });
            }))));
};
export default Modal;
//# sourceMappingURL=Modal.js.map